<video #target class="video-js" width="300" height="240" controls muted playsinline preload="none"></video>
